export enum DocumentType {
    NIF = 1,
    NIE,
    PASSPORT,
    OTHER
}

export interface DocumentClass {
    value: string;
    text: string;
    regex: string;
    validationType: DocumentType;
}

export const createDocumentClass = (data: any): DocumentClass => ({
    value: data.value,
    text: data.text,
    regex: data.documenttyperegexpr,
    validationType: parseInt(data.documenttypevalidation, 10)
});
